import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import Zoom from "react-medium-image-zoom"
import "react-medium-image-zoom/dist/styles.css"

const PhenologicalImage = ({ phenologicalStage }) => {
  const { allFile } = useStaticQuery(graphql`
    query {
      allFile(filter: { sourceInstanceName: { eq: "applePhenology" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(width: 350, placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)
  const images = allFile.edges.map(({ node }) => {
    return {
      name: node.name,
      node: node,
    }
  })
  const img = images.find((i) => i.name === phenologicalStage.value)

  return (
    <Zoom zoomMargin={200}>
      <GatsbyImage
        image={getImage(img.node)}
        alt={img.name}
        className="w-32 rounded-md"
      />
    </Zoom>
  )
}

export default PhenologicalImage
